import _ from '@/lodash';
import { IoIosArrowBack, IoIosArrowForward, IoIosMore } from 'react-icons/io';
import styles from './PagingNav.module.scss';
import { Link } from 'react-router-dom';

interface PagingNavProps {
  page: number;
  docs: any[];
  next?: number[];
}

function PagingNav(props: PagingNavProps) {
  const { page, next, docs } = props;

  const min = Math.max(page - 3, 1);

  const max =
    page === 1
      ? next?.[4] || next?.[3] || next?.[2] || next?.[1] || next?.[0] || page
      : next?.[2] || next?.[1] || next?.[0] || page;

  const range = _.range(min, max + 1);

  if (page === 1 && _.isEmpty(next)) {
    return null;
  }

  function getPageUrl(page: number) {
    const pageUrl = new URL(window.location.href);

    pageUrl.searchParams.set('page', _.toString(page));

    return pageUrl.toString();
  }

  return (
    <div className={styles.footer}>
      {page > 1 && (
        <Link className={styles.footerButton} to={getPageUrl(page - 1)}>
          <IoIosArrowBack />

          <span className="desktop-only">Back</span>
        </Link>
      )}

      {page > 4 && (
        <div className="desktop-only">
          <IoIosMore className={styles.dots} />
        </div>
      )}

      {page > 2 && (
        <div className="mobile-only">
          <IoIosMore className={styles.dots} />
        </div>
      )}

      {_.map(range, (currPage) => {
        const activeStyle = currPage === page ? styles.active : '';
        const desktopStyle =
          (page === 1 && Math.abs(currPage - page) > 3) ||
          (page > 1 && Math.abs(currPage - page) > 1)
            ? 'desktop-only'
            : '';

        return (
          <Link
            className={`${styles.pageNumber} ${activeStyle} ${desktopStyle}`}
            to={getPageUrl(currPage)}
            key={currPage}
          >
            {currPage}
          </Link>
        );
      })}

      {page === 1 && _.size(next) > 3 && <IoIosMore className={styles.dots} />}
      {page > 1 && _.size(next) > 1 && <IoIosMore className={styles.dots} />}

      {next && (
        <Link className={styles.footerButton} to={getPageUrl(page + 1)}>
          <span className="desktop-only">Next</span>

          <IoIosArrowForward />
        </Link>
      )}
    </div>
  );
}

export default PagingNav;
